import React from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import GeneralStore from './Stores/GeneralStore';
import ExclusiveStore from './Stores/ExclusiveStore';
import GenreStore from './Stores/GenreStore';
import StepManager from './StepManager';

import './Wizard.css';

export default class WizardHome extends React.Component {
	static propTypes = {
		// props from react router
		match: PropTypes.object,
		location: PropTypes.object,
		history: PropTypes.object,
	};

	state = {
		isAutoOpen: true,
	};

	render() {
		return (
			<div id="wizard">
				<GeneralStore>
					<ExclusiveStore>
						<GenreStore>
							<StepManager isAutoOpen={this.state.isAutoOpen} />
						</GenreStore>
					</ExclusiveStore>
				</GeneralStore>
			</div>
		);
	}

	componentDidMount() {
		const props = this.props;
		const params = qs.parse(props.location.search);
		const isAutoOpen = params.isAutoOpen === 'true';

		this.setState({ isAutoOpen });
	}
}
